import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const STATUS_CONFIG = {
  pending: { label: 'Pendente', bg: '#E8F5E9', border: '#C8E6C9', dot: '#43A047', text: '#2E7D32' },
  expired: { label: 'Expirado', bg: '#FFF3E0', border: '#FFE0B2', dot: '#FB8C00', text: '#E65100' },
  confirmed: { label: 'Confirmado', bg: '#F5F5F5', border: '#E0E0E0', dot: '#9E9E9E', text: '#616161' },
};

/**
 * SignupStatusChip - Indicador do status derivado de um cadastro pendente
 * (Admin Geral > Cadastros pendentes)
 * @param {Object} props
 * @param {'pending'|'expired'|'confirmed'} props.status
 */
function SignupStatusChip({ status }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.pending;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.6,
        px: 1.25,
        py: 0.4,
        borderRadius: '20px',
        backgroundColor: cfg.bg,
        border: `1px solid ${cfg.border}`,
        width: 'fit-content',
      }}
    >
      <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: cfg.dot, flexShrink: 0 }} />
      <Typography
        variant="caption"
        sx={{ fontWeight: 500, fontSize: '0.75rem', lineHeight: 1, color: cfg.text, whiteSpace: 'nowrap' }}
      >
        {cfg.label}
      </Typography>
    </Box>
  );
}

export default SignupStatusChip;
export { STATUS_CONFIG as SIGNUP_STATUS_CONFIG };
